import {
	getTopPicksAPI,
	getResultListAPI,
	getResultItemAPI,
} from '@/api/search'
import { toRaw } from 'vue'

const search = {
	namespaced: true,
	state: () => ({
		topPicks: [], // Top Picks数据
		resultList: [], // 搜索结果数据
		resultItem: {}, // 搜索结果个项
	}),
	mutations: {
		/* 设置Top Picks数据 */
		setTopPicks(state, topPicks) {
			state.topPicks = topPicks
		},
		/* 设置搜索结果数据 */
		setResultList(state, result) {
			state.resultList = result
		},
		setResultItem(state, resultItem) {
			const { id, res } = resultItem
			const initData = toRaw(state.resultItem)

			state.resultItem = { ...initData, [id]: res }
		},
	},
	actions: {
		/* 获取Top Picks数据 */
		async fetchTopPicks({ commit }) {
			const res = await getTopPicksAPI()
			commit('setTopPicks', res)
		},

		/* 获取搜索结果数据 */
		async fetchResultList({ commit }, data) {
			const res = await getResultListAPI(data)
			commit('setResultList', res)
		},

		/* 获取搜索结果个项详情 */
		async fetchResultItem({ commit }, id) {
			const res = await getResultItemAPI(id)
			commit('setResultItem', { id, res })
		},
	},
}

export default search
